<template>
  <v-app>
    <div style="background-color: white; height: 40px;" class="d-flex justify-space-between align-center px-6">
      <div style="color: #2d4f6c;"><strong>Satu-KPI</strong></div>
      <div style="color: #2d4f6c;">{{ timeNow }}</div>
    </div>
    <v-container
      fluid
      class="pa-0 d-flex align-center justify-center login-container"
      style="min-height: calc(100vh - 40px); background-color: #2d4f6c;"
    >
      <v-snackbar 
        v-model="snackbar.visible" 
        :color="snackbar.color" 
        :timeout="snackbar.timeout" 
        :top="snackbar.position === 'top'"
      >
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div><strong>{{ snackbar.title }}</strong></div>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-row no-gutters class="ma-0 pa-0" justify="center" align="center" style="width: 100%;">
        <v-col cols="12" md="6" lg="5" class="d-flex justify-center">
          <v-card class="rounded-xl elevation-8 pa-10 login-card" max-width="440" width="100%">
            <v-card-title class="justify-center pb-4">
              <v-img
                src="@/assets/hr.png"
                contain
                style="max-width: 120px;"
              />
            </v-card-title>

            <h1 class="pb-1 text-center">Ubah <span style="font-weight: 900;">Password</span></h1>
            <p class="text-center grey--text mb-6">
              Untuk keamanan akun <strong>Satu-KPI</strong> Anda,<br>silakan buat password baru
            </p>

            <v-form ref="form" @submit.prevent="changePassword">
              <v-text-field
                v-model="form.newPassword"
                label="Password Baru"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPassword = !showPassword"
                outlined
                dense
                prepend-inner-icon="mdi-lock-outline"
                hint="Minimal 8 karakter"
                :rules="[
                  v => !!v || 'Password baru wajib diisi',
                  v => (v && v.length >= 8) || 'Password minimal 8 karakter'
                ]"
                required
                class="mb-2"
              />
              <v-text-field
                v-model="form.confirmPassword"
                label="Konfirmasi Password Baru"
                :type="showConfirm ? 'text' : 'password'"
                :append-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showConfirm = !showConfirm"
                outlined
                dense
                prepend-inner-icon="mdi-lock-check"
                :rules="[
                  v => !!v || 'Konfirmasi password wajib diisi',
                  v => v === form.newPassword || 'Password tidak cocok'
                ]"
                required
                class="mb-4"
              />
              <v-btn
                color="#2d4f6c"
                block
                large
                depressed
                class="mt-2 white--text font-weight-bold"
                style="border-radius: 8px; letter-spacing: 1px;"
                type="submit"
                :loading="loading"
                :disabled="loading"
              >
                UBAH PASSWORD
              </v-btn>
            </v-form>

            <div class="text-center mt-6">
              <span class="caption grey--text text--darken-1">
                &copy; {{ new Date().getFullYear() }} J99Corp &mdash; Satu-KPI
              </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
	data() {
		return {
			snackbar: {
				color: null,
				icon: null,
				mode: null,
				position: "top",
				text: null,
				timeout: 7500,
				title: null,
				visible: false,
			},
			form: {
				newPassword: "",
				confirmPassword: "",
			},
			loading: false,
			showPassword: false,
			showConfirm: false,
			timeNow: "",
		};
	},
	mounted() {
		this.updateTime();
		setInterval(this.updateTime, 1000);
	},
	methods: {
		updateTime() {
			const now = new Date();
			const options = {
				weekday: "long",
				day: "numeric",
				month: "long",
				year: "numeric",
			};
			this.timeNow =
				now.toLocaleTimeString() +
				" | " +
				now.toLocaleDateString("id-ID", options);
		},
		async changePassword() {
			if (!this.$refs.form.validate()) {
				return;
			}

			if (this.form.newPassword !== this.form.confirmPassword) {
				this.snackbar = {
					visible: true,
					color: "error",
					icon: "mdi-alert-circle",
					title: "Error",
					text: "Password baru dan konfirmasi password tidak cocok",
					timeout: 5000,
					position: "top",
				};
				return;
			}

			this.loading = true;
			try {
				const response = await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/force-change-password`,
					{
						new_password: this.form.newPassword,
						new_password_confirmation: this.form.confirmPassword,
					},
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);

				// Check if response status is 200 and no error in response data
				if (response.status === 200 && response.data?.status !== "error") {
					// Update user status in store
					const user = this.$store.getters.getUser;
					if (user) {
						user.is_password_changed = 1;
						this.$store.commit("SET_USER", user);
						localStorage.setItem("user", JSON.stringify(user));
					}

					this.snackbar = {
						visible: true,
						color: "success",
						icon: "mdi-check-circle",
						title: "Berhasil",
						text: "Password berhasil diubah. ",
						timeout: 2000,
						position: "top",
					};

					// Redirect to dashboard or first active route after 2 seconds
					setTimeout(() => {
						const menus = this.$store.getters.getMenus;
						const firstActiveRoute = this.findFirstActiveRoute(menus);
						if (firstActiveRoute) {
							this.$router.push(firstActiveRoute);
						} else {
							this.$router.push("/dashboard");
						}
					}, 2000);
				} else {
					// Handle error response (status "error" in response data)
					const errorData = response.data;
					let errorMsg =
						errorData?.message || "Terjadi kesalahan saat mengubah password";

					// Check for field-specific errors
					if (errorData?.errors) {
						const errorFields = Object.keys(errorData.errors);
						if (errorFields.length > 0) {
							const firstError = errorData.errors[errorFields[0]];
							if (Array.isArray(firstError) && firstError.length > 0) {
								errorMsg = firstError[0];
							}
						}
					}

					this.snackbar = {
						visible: true,
						color: "error",
						icon: "mdi-alert-circle",
						title: "Gagal",
						text: errorMsg,
						timeout: 5000,
						position: "top",
					};
				}
			} catch (error) {
				// Handle network errors or HTTP error status codes
				const errorData = error.response?.data;
				let errorMsg = "Terjadi kesalahan saat mengubah password";

				if (errorData) {
					// Check for error message
					if (errorData.message) {
						errorMsg = errorData.message;
					}
					// Check for validation errors
					else if (errorData.errors) {
						const errorFields = Object.keys(errorData.errors);
						if (errorFields.length > 0) {
							const firstError = errorData.errors[errorFields[0]];
							if (Array.isArray(firstError) && firstError.length > 0) {
								errorMsg = firstError[0];
							}
						}
					}
				}

				this.snackbar = {
					visible: true,
					color: "error",
					icon: "mdi-alert-circle",
					title: "Gagal",
					text: errorMsg,
					timeout: 5000,
					position: "top",
				};
			} finally {
				this.loading = false;
			}
		},
		findFirstActiveRoute(menus) {
			if (!menus || !Array.isArray(menus)) return null;
			for (const menu of menus) {
				if (menu.is_active === 1 && menu.route) return menu.route;
				if (menu.children && Array.isArray(menu.children)) {
					const child = menu.children.find((c) => c.is_active === 1 && c.route);
					if (child) return child.route;
				}
			}
			return null;
		},
	},
};
</script>

<style>
.login-container {
	width: 100%;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	display: flex;
	align-items: center;
	justify-content: center;
}

@media (max-width: 600px) {
	.login-container {
		align-items: center !important;
		padding: 16px;
	}
	.login-card {
		padding: 16px !important;
		width: 100%;
		max-width: 100%;
	}
}
</style>
